export default __webpack_public_path__ + "static/media/house.84f1d964.svg";